module.exports = __webpack_public_path__ + "img/Informatikerin_EH_013.e9dc82d5.jpg";